import { type FC } from "react";

import { FormattedRelativeTime } from "react-intl";

const SECOND_MILLISECONDS = 1000;

export const RelativeResetTime: FC<{ replenishAt: Date }> = ({ replenishAt }) => {
    const secondsUntilReset = Math.max(Math.ceil((replenishAt.getTime() - Date.now()) / SECOND_MILLISECONDS), 0);

    return (
        <FormattedRelativeTime
            value={secondsUntilReset}
            unit="second"
            updateIntervalInSeconds={secondsUntilReset > 0 ? 1 : undefined}
            numeric="always"
        />
    );
};
